

export const preferenceMeta = {
  pets: {
    description: "I'm ok flying with pets on board",
  },
   children: {
    description: "I'm ok flying with children (14 and under) on board",
  },
   quiet: {
    description: "I generally prefer a quiet flight.",
  },
};

export const preferenceUseMeta = {
  pets: {
    description: "I generally fly with my pets on board",
  },
   children: {
    description: "I generally fly with one or more children",
  },
   quiet: {
    description: "My flights are always quiet",
  },
};